import { http } from '../request'
import type {
    UserLoginRequest,
    SMSLoginRequest,
    SendCodeRequest,
    PasswordResetRequest,
    UserLoginResponse,
    SMSLoginResponse,
    SendCodeResponse,
    PasswordResetResponse
} from '../types/auth'

/**
 * 认证相关 API
 */
export const authApi = {
    /**
     * 密码登录
     * POST /api/auth/login-password/
     */
    loginWithPassword(data: UserLoginRequest): Promise<UserLoginResponse> {
        return http.post<UserLoginResponse>('/api/auth/login-password/', data)
    },

    /**
     * 短信登录（用户不存在时自动注册）
     * POST /api/auth/login-sms/
     */
    loginWithSMS(data: SMSLoginRequest): Promise<SMSLoginResponse> {
        return http.post<SMSLoginResponse>('/api/auth/login-sms/', data)
    },

    /**
     * 发送验证码
     * POST /api/auth/send-code/
     */
    sendCode(data: SendCodeRequest): Promise<SendCodeResponse> {
        return http.post<SendCodeResponse>('/api/auth/send-code/', data)
    },

    /**
     * 密码重置（忘记密码）
     * POST /api/auth/reset-password/
     */
    resetPassword(data: PasswordResetRequest): Promise<PasswordResetResponse> {
        return http.post<PasswordResetResponse>('/api/auth/reset-password/', data)
    }
}

export default authApi 